// extracted by mini-css-extract-plugin
export var answer = "bx_fR";
export var arrow = "bx_9";
export var body = "bx_c";
export var category = "bx_cH";
export var contactIcons = "bx_fK";
export var current = "bx_fs";
export var fade = "bx_fN";
export var footer = "bx_cC";
export var footerText = "bx_cD";
export var icon = "bx_bw";
export var iconContainer = "bx_b4";
export var issue = "bx_fQ";
export var issueContainer = "bx_fM";
export var issueText = "bx_fP";
export var issues = "bx_fL";
export var left = "bx_bK";
export var padding = "bx_dt";
export var right = "bx_bY";
export var section = "bx_j";
export var selectors = "bx_fb";
export var subtitle = "bx_cR";
export var title = "bx_g";